/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import moment from 'moment';
import intl from 'react-intl-universal';
import 'shared/utils/analyticsUtil';
import { LANGUAGE_KEY_MAPPING } from './common/constants';
import enUS from './locales/en-US';
import zhCN from './locales/zh-CN';
import thTH from './locales/th-TH';

const OverseaEducationPage = React.lazy(() => import('./modules/education/pages/OverseaEducationPage'));
const RetirementPlannerPage = React.lazy(() => import('./modules/retirement/pages/RetirementPlannerPage'));
const InsurancePlannerPage = React.lazy(() => import('./modules/insurance/pages/InsurancePlannerPage'));
const MortgagePlannerPage = React.lazy(() => import('./modules/mortgage/pages/MortgagePlannerPage'));
const MedicalConciergeRequestPage = React.lazy(() => import('./modules/medicalconcierge/pages/MedicalConciergeRequestPage'));

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const country = urlParams.get('country');

const locales = {
	'en-US': enUS,
	'zh-CN': zhCN,
	'th-TH': thTH
};
const currentLanguage = navigator.language;
const getBrowserLanguage = () => {
	const keys = currentLanguage ? currentLanguage.split('-') : null;
	let languageKey = 'en';
	if (keys?.length > 0) {
		// eslint-disable-next-line prefer-destructuring
		languageKey = keys[0];
	}
	return LANGUAGE_KEY_MAPPING[languageKey] || null;
};

const theme = createMuiTheme({
	palette: {
		primary: {
			main: 'rgb(130, 190, 65)'
		},
		secondary: {
			main: 'rgb(34, 91, 171)'
		}
	},
	overrides: {
		MuiFormLabel: {
			root: {
				'&.Mui-required': {
					'&::after': {
						content:
							currentLanguage === 'th-TH' || country === 'TH'
								? '" (บังคับ)"'
								: currentLanguage === 'zh-CN'
								? '" (必填项)"'
								: '" (mandatory field)"',
						fontStyle: 'italic'
					}
				}
			},
			asterisk: {
				'&.MuiInputLabel-asterisk': {
					display: 'none'
				}
			}
		}
	}
});

function App() {
	// eslint-disable-next-line no-unused-vars
	const [localeInitialized, setLocaleInitialized] = useState(false);
	window.NEXT_PUBLIC_BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

	useEffect(() => {
		console.log('Init2');
		let appLocale = getBrowserLanguage();
		if (country === 'TH') {
			appLocale = 'th-TH';
		}
		// init method will load CLDR locale data according to currentLocale
		// react-intl-universal is singleton, so you should init it only once in your app
		/*
		 * Get browser's language
		 */
		if (appLocale) {
			moment.locale(appLocale);

			intl.init({
				currentLocale: appLocale,
				locales,
				// eslint-disable-next-line no-unused-vars
				warningHandler: (message, detail) => {
					console.warn(message);
				}
			}).then(() => {
				setLocaleInitialized(true);
			});
		}
	}, []);
	return (
		<ThemeProvider theme={theme}>
			<Router>
				<div className="App">
					<Switch>
						<React.Suspense fallback={<div>Loading...</div>}>
							<Route path="/oversea-study">
								<OverseaEducationPage />
							</Route>
							<Route path="/retirement-planner">
								<RetirementPlannerPage />
							</Route>
							<Route path="/insurance-planner">
								<InsurancePlannerPage />
							</Route>
							<Route path="/mortgage-planner">
								<MortgagePlannerPage />
							</Route>
							<Route path="/medical-concierge">
								<MedicalConciergeRequestPage />
							</Route>
							<Route exact path="/">
								<Redirect to="/oversea-study" />
							</Route>
						</React.Suspense>
					</Switch>
				</div>
			</Router>
		</ThemeProvider>
	);
}

export default App;
